<template>
	<div class="p4">
		<div class="lh150">
			<div class="xs-12">
				<core-form-input
					componentName="j-base-input-number"
					name="premium"
					type="float"
					v-validate="'required'"
					:validationErrors="errors"
					aria-autocompolete="none"
					v-model="gross"
					@enter="handleSave"
				></core-form-input>
				<!-- :value="value.grossAmount"
				@input="$emit('input', value)"-->
			</div>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
export default {
	components: {
		CoreFormInput
	},
	props: {
		value: Object
	},
	computed: {
		gross: {
			get() {
				return this.value.grossAmount
			},
			set(grossAmount) {
				this.$emit("input", {
					...this.value,
					grossAmount
				})
			}
		}
	},
	methods: {
		async handleSave() {
			console.log("handleSave", this.value, this.grossAmount)
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.$emit("input", {
				...this.value,
				grossAmount: this.grossAmount
			})
		},
		handleCancel() {
			this.$emit("cancelled")
		}
	}
}
</script>

<style></style>
